import { useSelector } from 'react-redux'

interface Auth {
  isSignedIn: boolean
  loading: boolean
}

const useIsUserSignedIn = () => {
  const { isSignedIn, loading } = useSelector(
    (state: { auth: Auth }) => state.auth,
  )
  return {
    isSignedIn,
    loading,
  }
}

export default useIsUserSignedIn
